const CAMPING_MAINKUR_DOMAIN = "campingplatz-mainkur.de";
const PRODUCTION_BOOKING_URL = "https://booking.campingplatz-mainkur.de";
const DEV_BOOKING_URL = "https://dev.booking.campingplatz-mainkur.de";
const TEST_BOOKING_URL = "https://test.booking.campingplatz-mainkur.de";

const HOST_BOOKING_URL: Record<string, string> = {
  "dev.app.campingplatz-mainkur.de": DEV_BOOKING_URL,
  "app.campingplatz-mainkur.de": PRODUCTION_BOOKING_URL,
  "test.app.campingplatz-mainkur.de": TEST_BOOKING_URL,
};

function bookingUrlForDomain(domain: string, env: "dev" | "prod" | "test"): string {
  if (domain === CAMPING_MAINKUR_DOMAIN) {
    if (env === "dev") return DEV_BOOKING_URL;
    if (env === "test") return TEST_BOOKING_URL;
    return PRODUCTION_BOOKING_URL;
  }
  if (env === "dev") return `https://dev.booking.${domain}`;
  if (env === "test") return `https://test.booking.${domain}`;
  return `https://booking.${domain}`;
}

/** Öffentliche Buchungs-URL passend zum Admin-Host (dev.app.* → dev.booking.*). */
export function resolveBookingUrl(hostname?: string): string {
  if (typeof window !== "undefined" && !hostname) {
    hostname = window.location.hostname;
  }

  if (hostname) {
    const mapped = HOST_BOOKING_URL[hostname];
    if (mapped) return mapped;

    if (hostname.startsWith("dev.booking.")) {
      return `https://${hostname}`;
    }
    if (hostname.startsWith("test.booking.")) {
      return `https://${hostname}`;
    }
    if (hostname.startsWith("booking.")) {
      return `https://${hostname}`;
    }

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return PRODUCTION_BOOKING_URL;
    }

    if (hostname.startsWith("dev.app.")) {
      const domain = hostname.slice("dev.app.".length);
      return bookingUrlForDomain(domain, "dev");
    }

    if (hostname.startsWith("test.app.")) {
      const domain = hostname.slice("test.app.".length);
      return bookingUrlForDomain(domain, "test");
    }

    if (hostname.startsWith("app.")) {
      const domain = hostname.slice("app.".length);
      return bookingUrlForDomain(domain, "prod");
    }
  }

  return PRODUCTION_BOOKING_URL;
}

/** Öffentliche Shop-URL passend zur Buchungs-URL (booking.* → shop.*). */
export function resolveShopUrl(hostname?: string): string {
  const booking = resolveBookingUrl(hostname);
  if (booking.includes("://dev.booking.")) return booking.replace("://dev.booking.", "://dev.shop.");
  if (booking.includes("://test.booking.")) return booking.replace("://test.booking.", "://test.shop.");
  if (booking.includes("://booking.")) return booking.replace("://booking.", "://shop.");
  return booking;
}
